import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// No redirects needed here - BrowserRouter handles everything
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);